import QueryString from 'query-string'
import { useLocation } from 'react-router-dom'

import { isSafeRedirect } from '@termly-web/common'

import Paths from 'constants/paths'


export default function useRedirectFromQueryString() {
  const { search } = useLocation()

  const {
    info,
    redirect,
  } = QueryString.parse(search)

  if ( isSafeRedirect(redirect) ) {
    return redirect
  }

  if ( info ) {
    return `${ Paths.CHECKOUT(search) }&from=sign-up`
  }

  return
}
